export class SetPaymentType
{
    public orderID: number;
    public paymentType: string;
}